遥感大数据
<template>
  <div class="main">
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      :stretch="stretch"
      style="height:60px"
    >
      <el-tab-pane label="卫星遥感正射影像产品" name="first">
        <Silhouette />
      </el-tab-pane>
      <el-tab-pane label="卫星遥感解译服务产品" name="second">
        <Interpreting />
      </el-tab-pane>
      <el-tab-pane label="高精度地形产品" name="third">
        <Terrain />
      </el-tab-pane>
    </el-tabs>

    <div id="right">
      <!--qq-->
      <div id="qq">
        <!-- <a target="_blank" href="tencent://message/?Menu=yes&uin=2994999647&Service=300&sigT=45a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a595b1714f9d45">  -->
        <el-link
          href="https://wpa.qq.com/msgrd?v=3&uin=3300756277&site=qqq&menu=yes"
          target="_blank"
          ref="elLink"
          id="qqLink"
        >
          <div class="qq-Picture">
            <img src="@/assets/images/qq.jpg" />
          </div>
          <div>技术咨询</div>
        </el-link>
      </div>
    </div>
  </div>
</template>
<script>
import Silhouette from "./components/silhouette";
import Interpreting from "./components/interpreting";
import Terrain from "./components/terrain";
export default {
  components: {
    Silhouette,
    Interpreting,
    Terrain,
  },
  data() {
    return {
      stretch: true,
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style scoped>
.main {
  width: 100%;
  min-height: 1500px;
}
/deep/ .el-tabs__item {
  height: 60px;
  line-height: 60px !important;
  font-size: 18px;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #d6ebff;
}

/* 浮层 */
#right {
  float: right;
  position: fixed;
  right: 20px;
  bottom: 200px;
  z-index: 99999999;
}
#qq {
  /* line-height: 80px; */
  width: 70px;
  height: 80px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
}
a {
  text-decoration: none;
  list-style: none;
  color: #000;
}
.qq-Picture img {
  width: 50px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/remoteDigData/remoteDigData.vue